/**
 * Enumeration of product types that support iframe embedding functionality.
 *
 * These values correspond to the toolUI[0].label field in Application objects
 * and determine which embedding strategy to use for each application type.
 */
export enum EmbeddableProductType {
  // SKYNET_TABLEAU = 'Skynet (Tableau)', // Commented out - pending implementation
  CLOUDSCAPE_POLARIS = 'Cloudscape (Polaris)',
  LEGACY_POLARIS = 'Legacy Polaris',
  PROPHECY = 'Prophecy',
  UNKNOWN = 'Unknown'
}
